<template>
  <v-container>
    <h1>{{ vendor.name }}</h1>

    <AdminBreadcrumbs :tail-text="vendorName" />

    <v-card class="lighten-5 orange" elevation="3">
      <v-card-title class="white--text orange"> Seksjoner </v-card-title>

      <v-container>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Produkter</v-card-title>

              <v-card-text>
                Administrer dine
                <router-link
                  :to="{
                    name: 'adminProducts',
                    params: { vendorId: vendorId },
                  }"
                  >produkter</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>Ordre</v-card-title>

              <v-card-text>
                Administrer dine
                <router-link
                  :to="{
                    name: 'adminOrders',
                    params: { vendorId: vendorId },
                  }"
                  >ordre</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>Innstillinger</v-card-title>

              <v-card-text>
                Administrer dine
                <router-link
                  :to="{
                    name: 'adminVendorEdit',
                    params: { vendorId: vendorId },
                  }"
                  >detaljer</router-link
                >,
                <router-link
                  :to="{
                    name: 'adminVendorPayment',
                    params: { vendorId: vendorId },
                  }"
                  >betalingsmetoder</router-link
                >
                eller
                <router-link
                  :to="{
                    name: 'adminVendorShipping',
                    params: { vendorId: vendorId },
                  }"
                  >leveringsmetoder</router-link
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs";

export default {
  name: "AdminVendorDetail",

  components: {
    AdminBreadcrumbs,
  },

  props: {
    vendorId: {
      type: String,
      required: false,
      default: "",
    },
  },

  data: function () {
    return {
      vendor: {},
    };
  },

  computed: {
    vendorName() {
      if (typeof this.vendor.name !== "undefined") {
        return this.vendor.name;
      }

      return "";
    },
  },

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);
  },
};
</script>

